export default function ContentZero({verticalTabsState}) {
  return (
    <div
      className={`content-0 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 0
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <span className="font-arial">
          <strong className="font-bold">Online Or</strong>{" "}
        </span>
        
        <span className="font-arial">
          <strong>Offline</strong>
        </span>
      </h2>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        Set up new stores quickly and easily with just an internet connection.
        Then use your Point of Sale everywhere, anytime.
      </p>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        While an internet connection is required to start the Point of Sale, it
        will stay operational even after complete disconnection.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-arial">
        <strong>Everything Your Shop Needs</strong>
      </h2>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        While an internet connection is required to start the Point of Sale, it
        will stay operational even after complete disconnection.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-arial">
        <strong>Keep In Touch With Your Customers</strong>
      </h2>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        And keep them coming back with loyalty programs.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-arial">
        <strong>Integrated Inventory Management</strong>
      </h2>

      <p className="mb-[25px] text-[16px] leading-[28px]">
        Real time control & accurate forecasts to manage procurements.
      </p>
    </div>
  );
}
